/* 單獨列傳：夏侯淵傳（設計見 docs/CAMPAIGN-XIAHOUYUAN.md）
 * 這一條列傳自己的章節、地圖都在這個檔案登錄，不用改 campaign/index.ts。
 * 地圖 id 一律加前綴「xiahouyuan_」，免得和其他列傳撞名。 */
// @ts-nocheck
import yanyu from '../maps/xiahouyuan_yanyu.ts';
import donghai from '../maps/xiahouyuan_donghai.ts';
import qishan from '../maps/xiahouyuan_qishan.ts';
import changli from '../maps/xiahouyuan_changli.ts';
import fuhan from '../maps/xiahouyuan_fuhan.ts';
import xhy1 from '../story/xiahouyuan1.ts';
import xhy2 from '../story/xiahouyuan2.ts';
import xhy3 from '../story/xiahouyuan3.ts';
import xhy4 from '../story/xiahouyuan4.ts';
import xhy5 from '../story/xiahouyuan5.ts';

export default {
  list: { id: 'xiahouyuan', name: '夏侯淵傳', years: '200–219', parts: [
    { name: '曹營篇', chapters: ['xiahouyuan-1', 'xiahouyuan-2'] },
    { name: '關右篇', chapters: ['xiahouyuan-3', 'xiahouyuan-4', 'xiahouyuan-5'] },
  ] },
  chapters: [xhy1, xhy2, xhy3, xhy4, xhy5],
  maps: { xiahouyuan_yanyu: yanyu, xiahouyuan_donghai: donghai, xiahouyuan_qishan: qishan, xiahouyuan_changli: changli, xiahouyuan_fuhan: fuhan },
};
